import { pick } from 'lodash'

import { toLines } from '../../../../common/utils'

const challengeSimpleDetailsFormInitialValues = challenge => ({
  ...pick(challenge, ['description', 'position', 'isExcludedFromSearch']),
  synonyms: toLines(challenge.synonyms),
})

export default challengeSimpleDetailsFormInitialValues
